export default {
  home: {
    viewTitle: "OverView",
    tabTitle: "Home",
    tooltip: {
      prebid: {
        text1:
          "- Prebid Analyticsで計測するデータには、オークション発生時からImpressionまでが含まれますが、各SSP/ DSP側で計測している確定値との乖離が発生することをご留意ください。",
        text2:
          "- 無効トラフィック（IVT）やユーザー起因の通信エラーにより、計測数値が欠損する可能性があります。またSSPのエラーなどによりCPM単価が急激に変動する可能性があります。",
      },
      gam: {
        text1:
          "- こちらのデータソースはGoogleAdManagerのデータです。Adserverベースの数値となるため、3rdpartyベンダーの数値はKeyvalueでの連携に伴い、 各SSP/ DSP側で計測している確定値との乖離が発生することをご留意ください。",
        text2:
          "- 無効トラフィック（IVT）やユーザー起因の通信エラーにより、計測数値が欠損する可能性があります。またSSP のエラーなどによりCPM単価が急激に変動する可能性があります。",
      },
    },
    missingData: "欠落しているデータがあります",
    periodSpecification: {
      startDate: "開始日",
      endDate: "終了日",
    },
    tabChangeDialog: {
      title: "確認",
      text: "指定された期間内にスクレイピングデータが更新されていない日付が含まれるため、開始日と終了日を調整して表示します。よろしいですか？",
    },
    text: {
      revenue: {
        title: "Estimated Revenue",
      },
      impression: {
        title: "Impression",
      },
      ecpm: {
        title: "eCPM",
      },
      expectedData: {
        tooltip: {
          text: "- 計算の都合上、毎月1〜5日及び末日には着地予想データが表示されないことをご留意ください。<br>- 表記数値は当月の数値となり、期間指定とは連動しないことにご注意ください。",
        },
      },
      filter: {
        title: "Filter",
        label: {
          publisher: "パブリッシャー",
          client: "クライアント",
          period: "期間選択",
        },
        default: "指定なし",
        tooltip: {
          reload: "ダッシュボードを更新",
        },
      },
      overAllTrend: {
        title: "全体推移",
        label: {
          revenueChart: "Revenue",
          impressionChart: "Impression",
        },
      },
      demandSale: {
        title: "デマンド別売上",
        tableHeader: {
          vendor: "Vendor",
          revenue: "Revenue",
          revenueBreakdown: "Revenue<br>breakdown",
        },
        summarizedVendorName: "Others",
      },
      cpmTransition: {
        title: "CPM推移",
        label: {
          cpmTransitionChart: "CPM",
          avgTransitionChart: "CPM（推定市場平均）",
        },
      },
      auctionTime: {
        title: "Auction Time",
      },
    },
  },
};
